import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 80vh;
`;

export const Home = styled.a`
  display: flex;
  position: absolute;
  font-size: 2em;
  text-decoration: none;
  color: inherit;

  &:hover,
  &:focus,
  &:active {
    text-decoration: none;
    color: inherit;
  }

  @media (max-width: 900px) {
    font-size: 1.4em;
  }
`;
